import { Box, CircularProgress, MenuItem, Select } from '@mui/material';
import React from 'react';

import { useStyles } from './styles';

type DropDownProps<T> = {
  options: T[],
  value?: T | string,
  defaultValue?: string,
  optionValue: keyof T,
  optionText: keyof T,
  defaultText: string,
  onChange: (value: string) => void,
  disabled?: boolean,
  isDataLoading?: Boolean
}

export function DropDown<T>({
  options,
  value,
  defaultValue = '',
  optionValue,
  optionText,
  defaultText,
  onChange,
  disabled = false,
  isDataLoading = false
}: DropDownProps<T>) {
  const classes = useStyles<T>({ value, disabled });
  return (
    <Select
      variant="standard"
      displayEmpty
      value={value}
      defaultValue={defaultValue}
      onChange={(e) => onChange(e.target.value as string)}
      className={classes.select}
      disableUnderline
      fullWidth
      disabled={disabled}
      MenuProps={{ classes: { paper: classes.menuPaper } }}
    >
      <MenuItem value="" className={classes.menuItem}>
        <Box className={classes.defaultItemContainer}>
          {defaultText}
          {isDataLoading && (<CircularProgress color="primary" size={12} />)}
        </Box>
      </MenuItem>
      {options.map((option) => (
        <MenuItem
          key={String(option[optionValue as string])}
          className={classes.menuItem}
          selected={option[optionValue as string] as string === value}
          value={option[optionValue as string] as string}
        >
          {option[optionText]}
        </MenuItem>
      ))}
    </Select>
  );
}
